module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("First Sentient Publications edition 2011")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Copyright © 2024 by Tamarack Song")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "noindentc"
  }, [_vm._v("All rights reserved. This book, or parts thereof, may not be reproduced in any form without")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("permission, except in the case of brief quotations embodied in critical articles and reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentc"
  }, [_vm._v("A paperback original")])]), _c('p', {
    staticClass: "noindentc"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Cover design and book design by Kim Johansen, Black Dog Design, "), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    attrs: {
      "href": "http://www.blackdogdesign.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.blackdogdesign.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentc"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "noindentc"
  }, [_vm._v("Song, Tamarack, 1948-")]), _vm._v(" "), _c('p', {
    staticClass: "indenti"
  }, [_vm._v("Song of trusting the heart : a classic Zen poem for daily meditation /")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tamarack Song ; artwork by Jan Zaremba. -- 1st.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indentr"
  }, [_vm._v("Summary: “An adaptation of an ancient Chinese scripture beloved by sages")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and considered a cornerstone of Zen Buddhism”-- Provided by publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ISBN 978-1-59181-175-6 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1. Sengcan, d. 606. Xin xin ming. 2. Spiritual life--Zen Buddhism. I.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Zaremba, Jan, 1941-II. Sengcan, d. 606. Xin xin ming. English. 2011. III.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Title.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("BQ9288.S463S66 2011")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("294.3'4435--dc23")]), _vm._v(" "), _c('p', {
    staticClass: "noindentB"
  }, [_vm._v("2011030897")]), _vm._v(" "), _c('p', {
    staticClass: "noindentc"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("SENTIENT PUBLICATIONS, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "noindentB"
  }, [_vm._v("A Limited Liability Company")]), _vm._v(" "), _c('p', {
    staticClass: "noindentB"
  }, [_vm._v("1113 Spruce Street")]), _vm._v(" "), _c('p', {
    staticClass: "noindentB"
  }, [_vm._v("Boulder, CO 80302")]), _vm._v(" "), _c('p', {
    staticClass: "noindentB"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.sentientpublications.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.sentientpublications.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59084f46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 66
// module chunks = 0